import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../../HelmetWrapper";
import { selectUser } from "../../../components/auth/auth.selector";
import DailyTarget from "../common/DailyTarget";

const DailyTargetPage = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Dashboard">
      <Container fluid className="px-50px pb-50px home-container">
        <Row>
          <Col>
            <DailyTarget user={userInfoData} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DailyTargetPage;
